import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { DeliveryPickupForm } from '@pt/models';

@Component({
  standalone: false,
  selector: 'pu-delivery-view-pickup',
  templateUrl: './pickup.component.html',
  styleUrls: ['./pickup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PickupComponent {
  delivery = input<DeliveryPickupForm>();
}
